// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDV9RDt9i-bYHT4R2ADgXu-DwyMYDaTreE",
  authDomain: "tblclass01app.firebaseapp.com",
  projectId: "tblclass01app",
  storageBucket: "tblclass01app.firebasestorage.app",
  messagingSenderId: "891310596487",
  appId: "1:891310596487:web:25908055f54e147990b322",
  measurementId: "G-QCDVLNWX88"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app, 'classapp01');

export { db };